import { Redirect, Slot, useMatch } from 'app/routx-router'
import FlowPageLayout from 'app/src/layouts/FlowPageLayout'
import OfflineLayout from 'app/src/layouts/OfflineLayout'
import { useToken } from 'app/state'
import { isNil } from 'lodash-es'

export const settings = {
  public: 'only'
}

const Layout = () => {
  const [token] = useToken()
  const isLoggedIn = !isNil(token)

  const matchRegister = useMatch('/auth/register')

  const matchPasswordReset = useMatch('/auth/reset-password/*/*')
  const matchEmailVerification = useMatch('/auth/verify-email/*')
  const matchConfirmEmailChange = useMatch('/auth/confirm-email-change/*')

  const canBeAccessedOnline =
    !isNil(matchPasswordReset) || !isNil(matchEmailVerification) || !isNil(matchConfirmEmailChange)

  //add register to allow settings preferences about onboarding context before layout is unmounted
  return isLoggedIn && !canBeAccessedOnline && isNil(matchRegister) ? (
    <Redirect to='/' replace />
  ) : canBeAccessedOnline ? (
    <FlowPageLayout>
      <Slot />
    </FlowPageLayout>
  ) : (
    <OfflineLayout $headerPosition={!matchRegister ? 'top' : 'left'}>
      <Slot />
    </OfflineLayout>
  )
}

export const Component = Layout
export default Layout
